//exports.BASE_URL  = "http://103.112.4.139:3000/";
exports.BASE_URL="https://secure.infytrix.live:3000/";//PROD
//exports.BASE_URL = "https://secure.infytrix.live:3001/"; //UAT
//  exports.BASE_URL = "https://secure.infytrix.live:3002/"; //UAT-TWO
// exports.BASE_URL = "https://infytrix-app-backup-298189d8f896.herokuapp.com/" // Backup
//exports.BASE_URL = "http://localhost:8000/";

//exports.BASE_URL = "https://infytrix-app-backup-298189d8f896.herokuapp.com/" //UAT
//exports.BASE_URL = "https://infytrix-backend-5eaf63f8ac6c.herokuapp.com/";
exports.FLASK_EXCEL_API_URL = "https://flask-excel-api-d6a79afc3728.herokuapp.com/";
//exports.FLASK_EXCEL_API_URL = 'http://127.0.0.1:5000/'
//COLOR
exports.PRIMARY = {
  P_Light: "#F7F9FB",
  P_Blue: "#E3F5FF",
  P_Purple: "#E5ECF6",
  P_Purple50: "#E5ECF680",
  P_BLue: "#1886FE",
};
exports.SECONDARY = {
  S_Purple_A: "#95A4FC",
  S_Purple_B: "#C6C7F8",
  S_Blue_A: "#A8C5DA",
  S_Blue_B: "#B1E3FF",
  S_Green_A: "#A1E3CB",
  S_Green_B: "#BAEDBD",
  S_Yellow: "#FFE999",
  S_Red: "#FF6565",
};
exports.BLACK = {
  B_100: "#1C1C1C",
  B_80: "#1C1C1CCC",
  B_40: "#1C1C1C66",
  B_20: "#1C1C1C33",
  B_10: "#1C1C1C1A",
  B_5: "#1C1C1C0D",
};

exports.WHITE = {
  W_100: "#FFFFFF",
  W_80: "#FFFFFFCC",
  W_40: "#FFFFFF66",
  W_20: "#FFFFFF33",
  W_10: "#FFFFFF1A",
  W_5: "#FFFFFF0D",
};
exports.STATUS = {
  S_Green: "#007F5F",
  S_Red: "#D72C0D",
  S_Red10: "rgba(215,44,13,0.1)", // "#D72C0D",
  S_Green10: "rgba(0, 127, 95, 0.1)", //"#007F5F"
};

// static comparison table for Drill Through
// static object
exports.SUMMARY_DRILL_TABLE_DATA = [
  {
    type: "principal_category",
    name: "Accessories",
    row: [
      [
        {
          date: '2025-04-01',
          "2025-04-01": {
            impressions: 100,
            clicks: 150,
            spend: 200,
            ad_sales: 125,
            ad_sales_perc: 175,
          }
        },
        {
          date: '2025-04-02',
          "2025-04-02": {
            impressions: 100,
            clicks: 150,
            spend: 200,
            ad_sales: 125,
            ad_sales_perc: 175,
          }
        }
      ]
    ],
    children: [
      {
        type: "main_category",
        name: "Combo",
        row: [
          [
            {
              date: '2025-04-01',
              "2025-04-01": {
                impressions: 100,
                clicks: 150,
                spend: 200,
                ad_sales: 125,
                ad_sales_perc: 175,
              }
            },
            {
              date: '2025-04-02',
              "2025-04-02": {
                impressions: 100,
                clicks: 150,
                spend: 200,
                ad_sales: 125,
                ad_sales_perc: 175,
              }
            }
          ]
        ],
        children: [
          {
            type: "category",
            name: "Hair Accessories 1",
            row: [
              [
                {
                  date: '2025-04-01',
                  "2025-04-01": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                },
                {
                  date: '2025-04-02',
                  "2025-04-02": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                }
              ]
            ],
            children: [
              {
                type: "sub_category",
                name: "Comb Combo",
                row: [
                  [
                    {
                      date: '2025-04-01',
                      "2025-04-01": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    },
                    {
                      date: '2025-04-02',
                      "2025-04-02": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    }
                  ]
                ],
                children: [
                  {
                    type: "product_name",
                    name: "Wide Tooth Comb + Neem Bhringraj Hair Oil",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "CB-KNC-WNBO-02",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BQBJGX6N",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQBMVK9V",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: "product_name",
                    name: "Wide Tooth Comb + Olive Almond Vit-E Hair Oil",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "CB-KNC-WOLO-02",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BQBJGX6N",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQ7CL8DD",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: "category",
            name: "Body Accessories 1",
            row: [
              [
                {
                  date: '2025-04-01',
                  "2025-04-01": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                },
                {
                  date: '2025-04-02',
                  "2025-04-02": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                }
              ]
            ],
            children: [
              {
                type: "sub_category",
                name: "Loofah",
                row: [
                  [
                    {
                      date: '2025-04-01',
                      "2025-04-01": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    },
                    {
                      date: '2025-04-02',
                      "2025-04-02": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    }
                  ]
                ],
                children: [
                  {
                    type: "product_name",
                    name: "Loofah Pack of 2",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "AC-SDL-LO2-00",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0B561VFWK",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BF11QP2M",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: "product_name",
                    name: "Loofah Pack of 4",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "AC-SDL-LO4-00",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BF126JX3",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQBKXVGR",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "main_category",
        name: "Non Combo",
        row: [
          [
            {
              date: '2025-04-01',
              "2025-04-01": {
                impressions: 100,
                clicks: 150,
                spend: 200,
                ad_sales: 125,
                ad_sales_perc: 175,
              }
            },
            {
              date: '2025-04-02',
              "2025-04-02": {
                impressions: 100,
                clicks: 150,
                spend: 200,
                ad_sales: 125,
                ad_sales_perc: 175,
              }
            }
          ]
        ],
        children: [
          {
            type: "category",
            name: "Hair Accessories 1",
            row: [
              [
                {
                  date: '2025-04-01',
                  "2025-04-01": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                },
                {
                  date: '2025-04-02',
                  "2025-04-02": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                }
              ]
            ],
            children: [
              {
                type: "sub_category",
                name: "Comb Combo",
                row: [
                  [
                    {
                      date: '2025-04-01',
                      "2025-04-01": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    },
                    {
                      date: '2025-04-02',
                      "2025-04-02": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    }
                  ]
                ],
                children: [
                  {
                    type: "product_name",
                    name: "Wide Tooth Comb + Neem Bhringraj Hair Oil",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "CB-KNC-WNBO-02",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BQBJGX6N",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQBMVK9V",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: "product_name",
                    name: "Wide Tooth Comb + Olive Almond Vit-E Hair Oil",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "CB-KNC-WOLO-02",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BQBJGX6N",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQ7CL8DD",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            type: "category",
            name: "Body Accessories 1",
            row: [
              [
                {
                  date: '2025-04-01',
                  "2025-04-01": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                },
                {
                  date: '2025-04-02',
                  "2025-04-02": {
                    impressions: 100,
                    clicks: 150,
                    spend: 200,
                    ad_sales: 125,
                    ad_sales_perc: 175,
                  }
                }
              ]
            ],
            children: [
              {
                type: "sub_category",
                name: "Loofah",
                row: [
                  [
                    {
                      date: '2025-04-01',
                      "2025-04-01": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    },
                    {
                      date: '2025-04-02',
                      "2025-04-02": {
                        impressions: 100,
                        clicks: 150,
                        spend: 200,
                        ad_sales: 125,
                        ad_sales_perc: 175,
                      }
                    }
                  ]
                ],
                children: [
                  {
                    type: "product_name",
                    name: "Loofah Pack of 2",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "AC-SDL-LO2-00",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0B561VFWK",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BF11QP2M",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: "product_name",
                    name: "Loofah Pack of 4",
                    row: [
                      [
                        {
                          date: '2025-04-01',
                          "2025-04-01": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        },
                        {
                          date: '2025-04-02',
                          "2025-04-02": {
                            impressions: 100,
                            clicks: 150,
                            spend: 200,
                            ad_sales: 125,
                            ad_sales_perc: 175,
                          }
                        }
                      ]
                    ],
                    children: [
                      {
                        type: "style_code",
                        name: "AC-SDL-LO4-00",
                        row: [
                          [
                            {
                              date: '2025-04-01',
                              "2025-04-01": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            },
                            {
                              date: '2025-04-02',
                              "2025-04-02": {
                                impressions: 100,
                                clicks: 150,
                                spend: 200,
                                ad_sales: 125,
                                ad_sales_perc: 175,
                              }
                            }
                          ]
                        ],
                        children: [
                          {
                            type: "model_code",
                            name: "B0BF126JX3",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                          {
                            type: "model_code",
                            name: "B0BQBKXVGR",
                            row: [
                              [
                                {
                                  date: '2025-04-01',
                                  "2025-04-01": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                },
                                {
                                  date: '2025-04-02',
                                  "2025-04-02": {
                                    impressions: 100,
                                    clicks: 150,
                                    spend: 200,
                                    ad_sales: 125,
                                    ad_sales_perc: 175,
                                  }
                                }
                              ]
                            ],
                            children: []
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  }
  // {
  //   type: "principal_category",
  //   name: "Baby Care",
  //   row: [
  //     [
  //       {
  //         date: '2025-04-01', 
  //         "2025-04-01":{
  //           impressions: 100,
  //           clicks: 150,
  //           spend: 200,
  //           ad_sales: 125,
  //           ad_sales_perc: 175,
  //         }
  //       },
  //       {
  //         date: '2025-04-02', 
  //         "2025-04-02":{
  //           impressions: 100,
  //           clicks: 150,
  //           spend: 200,
  //           ad_sales: 125,
  //           ad_sales_perc: 175,
  //         }
  //       }
  //     ]
  //   ],
  //   children: [
  //     // {
  //     //   type: "main_category",
  //     //   name: "Non Combo",
  //     //   row: [
  //     //     [
  //     //       {
  //     //         date: '2025-04-01', 
  //     //         "2025-04-01":{
  //     //           impressions: 100,
  //     //           clicks: 150,
  //     //           spend: 200,
  //     //           ad_sales: 125,
  //     //           ad_sales_perc: 175,
  //     //         }
  //     //       },
  //     //       {
  //     //         date: '2025-04-02', 
  //     //         "2025-04-02":{
  //     //           impressions: 100,
  //     //           clicks: 150,
  //     //           spend: 200,
  //     //           ad_sales: 125,
  //     //           ad_sales_perc: 175,
  //     //         }
  //     //       }
  //     //     ]
  //     //   ],
  //     //   children: [
  //     //     {
  //     //       type: "cat",
  //     //       name: "Baby Bath Essentials",
  //     //       row: [
  //     //         [
  //     //           {
  //     //             date: '2025-04-01', 
  //     //             "2025-04-01":{
  //     //               impressions: 100,
  //     //               clicks: 150,
  //     //               spend: 200,
  //     //               ad_sales: 125,
  //     //               ad_sales_perc: 175,
  //     //             }
  //     //           },
  //     //           {
  //     //             date: '2025-04-02', 
  //     //             "2025-04-02":{
  //     //               impressions: 100,
  //     //               clicks: 150,
  //     //               spend: 200,
  //     //               ad_sales: 125,
  //     //               ad_sales_perc: 175,
  //     //             }
  //     //           }
  //     //         ]
  //     //       ],
  //     //       children: [
  //     //         {
  //     //           type: "sCat",
  //     //           name: "Baby Powder",
  //     //           row: [
  //     //             [
  //     //               {
  //     //                 date: '2025-04-01', 
  //     //                 "2025-04-01":{
  //     //                   impressions: 100,
  //     //                   clicks: 150,
  //     //                   spend: 200,
  //     //                   ad_sales: 125,
  //     //                   ad_sales_perc: 175,
  //     //                 }
  //     //               },
  //     //               {
  //     //                 date: '2025-04-02', 
  //     //                 "2025-04-02":{
  //     //                   impressions: 100,
  //     //                   clicks: 150,
  //     //                   spend: 200,
  //     //                   ad_sales: 125,
  //     //                   ad_sales_perc: 175,
  //     //                 }
  //     //               }
  //     //             ]
  //     //           ],
  //     //           children: [
  //     //             {
  //     //               type: "mpn",
  //     //               name: "Raw Haldi Baby Powder",
  //     //               row: [
  //     //                 [
  //     //                   {
  //     //                     date: '2025-04-01', 
  //     //                     "2025-04-01":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   },
  //     //                   {
  //     //                     date: '2025-04-02', 
  //     //                     "2025-04-02":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   }
  //     //                 ]
  //     //               ],
  //     //               children: [
  //     //                 {
  //     //                   type: "sku",
  //     //                   name: "BA-BP-RH-150",
  //     //                   row: [
  //     //                     [
  //     //                       {
  //     //                         date: '2025-04-01', 
  //     //                         "2025-04-01":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       },
  //     //                       {
  //     //                         date: '2025-04-02', 
  //     //                         "2025-04-02":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       }
  //     //                     ]
  //     //                   ],
  //     //                   children: [
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "B0BFRYK5GJ",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "B0C8JN7DH6",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                   ],
  //     //                 },
  //     //               ],
  //     //             },
  //     //             {
  //     //               type: "mpn",
  //     //               name: "Charoli Milk Almond Baby Ubtan",
  //     //               row: [
  //     //                 [
  //     //                   {
  //     //                     date: '2025-04-01', 
  //     //                     "2025-04-01":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   },
  //     //                   {
  //     //                     date: '2025-04-02', 
  //     //                     "2025-04-02":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   }
  //     //                 ]
  //     //               ],
  //     //               children: [
  //     //                 {
  //     //                   type: "sku",
  //     //                   name: "BA-BU-CMA-080",
  //     //                   row: [
  //     //                     [
  //     //                       {
  //     //                         date: '2025-04-01', 
  //     //                         "2025-04-01":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       },
  //     //                       {
  //     //                         date: '2025-04-02', 
  //     //                         "2025-04-02":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       }
  //     //                     ]
  //     //                   ],
  //     //                   children: [
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "B0BFRKFGC6",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "BA-BU-GG-080",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                   ],
  //     //                 },
  //     //               ],
  //     //             },
  //     //           ],
  //     //         },
  //     //       ],
  //     //     },
  //     //     {
  //     //       type: "cat",
  //     //       name: "Baby Oils",
  //     //       row: [
  //     //         [
  //     //           {
  //     //             date: '2025-04-01', 
  //     //             "2025-04-01":{
  //     //               impressions: 100,
  //     //               clicks: 150,
  //     //               spend: 200,
  //     //               ad_sales: 125,
  //     //               ad_sales_perc: 175,
  //     //             }
  //     //           },
  //     //           {
  //     //             date: '2025-04-02', 
  //     //             "2025-04-02":{
  //     //               impressions: 100,
  //     //               clicks: 150,
  //     //               spend: 200,
  //     //               ad_sales: 125,
  //     //               ad_sales_perc: 175,
  //     //             }
  //     //           }
  //     //         ]
  //     //       ],
  //     //       children: [
  //     //         {
  //     //           type: "sCat",
  //     //           name: "Baby Maahu",
  //     //           row: [
  //     //             [
  //     //               {
  //     //                 date: '2025-04-01', 
  //     //                 "2025-04-01":{
  //     //                   impressions: 100,
  //     //                   clicks: 150,
  //     //                   spend: 200,
  //     //                   ad_sales: 125,
  //     //                   ad_sales_perc: 175,
  //     //                 }
  //     //               },
  //     //               {
  //     //                 date: '2025-04-02', 
  //     //                 "2025-04-02":{
  //     //                   impressions: 100,
  //     //                   clicks: 150,
  //     //                   spend: 200,
  //     //                   ad_sales: 125,
  //     //                   ad_sales_perc: 175,
  //     //                 }
  //     //               }
  //     //             ]
  //     //           ],
  //     //           children: [
  //     //             {
  //     //               type: "mpn",
  //     //               name: "Balamool Nimbuka 100ml",
  //     //               row: [
  //     //                 [
  //     //                   {
  //     //                     date: '2025-04-01', 
  //     //                     "2025-04-01":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   },
  //     //                   {
  //     //                     date: '2025-04-02', 
  //     //                     "2025-04-02":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   }
  //     //                 ]
  //     //               ],
  //     //               children: [
  //     //                 {
  //     //                   type: "sku",
  //     //                   name: "BA-BU-MN2-080",
  //     //                   row: [
  //     //                     [
  //     //                       {
  //     //                         date: '2025-04-01', 
  //     //                         "2025-04-01":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       },
  //     //                       {
  //     //                         date: '2025-04-02', 
  //     //                         "2025-04-02":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       }
  //     //                     ]
  //     //                   ],
  //     //                   children: [
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "B0BFRJX416",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "B0B4JMH7Z6",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                   ],
  //     //                 },
  //     //               ],
  //     //             },
  //     //             {
  //     //               type: "mpn",
  //     //               name: "Balamool Sunthi 100ml",
  //     //               row: [
  //     //                 [
  //     //                   {
  //     //                     date: '2025-04-01', 
  //     //                     "2025-04-01":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   },
  //     //                   {
  //     //                     date: '2025-04-02', 
  //     //                     "2025-04-02":{
  //     //                       impressions: 100,
  //     //                       clicks: 150,
  //     //                       spend: 200,
  //     //                       ad_sales: 125,
  //     //                       ad_sales_perc: 175,
  //     //                     }
  //     //                   }
  //     //                 ]
  //     //               ],
  //     //               children: [
  //     //                 {
  //     //                   type: "sku",
  //     //                   name: "BA-WMA-BS-100",
  //     //                   row: [
  //     //                     [
  //     //                       {
  //     //                         date: '2025-04-01', 
  //     //                         "2025-04-01":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       },
  //     //                       {
  //     //                         date: '2025-04-02', 
  //     //                         "2025-04-02":{
  //     //                           impressions: 100,
  //     //                           clicks: 150,
  //     //                           spend: 200,
  //     //                           ad_sales: 125,
  //     //                           ad_sales_perc: 175,
  //     //                         }
  //     //                       }
  //     //                     ]
  //     //                   ],
  //     //                   children: [
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "product-1",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                     {
  //     //                       type: "product_code",
  //     //                       name: "product-2",
  //     //                       row: [
  //     //                         [
  //     //                           {
  //     //                             date: '2025-04-01', 
  //     //                             "2025-04-01":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           },
  //     //                           {
  //     //                             date: '2025-04-02', 
  //     //                             "2025-04-02":{
  //     //                               impressions: 100,
  //     //                               clicks: 150,
  //     //                               spend: 200,
  //     //                               ad_sales: 125,
  //     //                               ad_sales_perc: 175,
  //     //                             }
  //     //                           }
  //     //                         ]
  //     //                       ],
  //     //                     },
  //     //                   ],
  //     //                 },
  //     //               ],
  //     //             },
  //     //           ],
  //     //         },
  //     //       ],
  //     //     },
  //     //   ],
  //     // },
  //   ],
  // },
];

